import { useTranslation } from 'react-i18next';
import { PostModal } from '../shared';
import { HistoryTemplate } from './history-template';
import { DetailsTemplate } from './details-template';

enum TabType {
  Details = 'Details',
  History = 'History'
}

export interface TemplateProps {
  hidePostHistory?: boolean;
}

export const Template = ({ hidePostHistory }: TemplateProps) => {
  const { t } = useTranslation();

  return (
    <PostModal.Tabs
      defaultTab={TabType.Details}
      tabs={[
        { label: t('Post Detail'), value: TabType.Details },
        ...(!hidePostHistory ? [{ label: t('History'), value: TabType.History }] : [])
      ]}
    >
      {({ selectedTab }) =>
        selectedTab === TabType.History && !hidePostHistory ? <HistoryTemplate /> : <DetailsTemplate />
      }
    </PostModal.Tabs>
  );
};
